export enum DialogCta {
  CONFIRM = "confirm",
  CANCEL = "cancel",
}
